module.exports = __webpack_public_path__ + "media/images/pages/weed_button-29aae03b1f79859ce191eb10d676a2f3.png";